<template>
  <div>
    <b-modal
      id="block-driver"
      ref="blockDriverModalRef"
      title="Block Driver"
      :no-close-on-backdrop="submitting"
      :no-close-on-esc="submitting"
      :cancel-disabled="submitting"
      :ok-disabled="submitting"
      :hide-header-close="submitting"
      @ok="submitInactivation"
      @hidden="hiddenHandler"
    >
      <b-card-text>
        <validation-observer
          ref="blockDriverFormRef"
        >
          <b-form
            autocomplete="off"
            class="p-2"
            @submit.prevent="submitInactivation"
          >
            <b-form-group
              label="Block Reason"
              label-for="block-reason"
            >
              <v-select
                id="block-reason"
                v-model="blockReason"
                :options="blockingReasons"
              />
            </b-form-group>

            <validation-provider
              #default="{ errors }"
              name="Block Note"
              rules="required"
            >
              <b-form-group
                label="Block Note"
                label-for="blockDriver-note"
              >
                <b-form-input
                  id="blockDriver-note"
                  v-model="inactivation.note"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>

            <b-form-group
              label="Description"
              label-for="blockDriver-description"
            >
              <b-form-textarea
                id="blockDriver-description"
                v-model="inactivation.description"
              />
            </b-form-group>

            <b-form-group
              label="Auto Resolve On"
            >
              <flat-pickr
                v-model="inactivation.autoResolveOn"
                class="form-control"
                :config="{ enableTime: true, minuteIncrement: 60}"
              />
            </b-form-group>
          </b-form>

        </validation-observer>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BCardText, BForm, BFormInput, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref, computed, reactive } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'

export default {
  components: {
    BModal,
    BCardText,
    BForm,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    vSelect,
    ValidationObserver,
    flatPickr,
  },

  setup(_, ctx) {
    const blockingReasons = ['Permanent', 'Penalty', 'Update', 'Deactivate']
    const blockReason = ref('Permanent')
    const blockDriverModalRef = ref(null)
    const blockDriverFormRef = ref(null)
    const user = computed(() => store.getters['auth/getLoggedUser'])
    const INACTIVATION_STATE_SNAPSHOT = {
      driver: router.currentRoute.params.id,
      inactivationReason: 'd636af3d-c62e-430b-9d4b-1b0b75ef2b9f',
      note: '',
      createdBy: user.value.email,
      isResolved: false,
      autoResolveOn: '',
      description: '',
    }
    const submitting = ref(false)
    const inactivation = reactive({ ...INACTIVATION_STATE_SNAPSHOT })

    const submitInactivation = async bvModalEvt => {
      bvModalEvt.preventDefault()
      if (submitting.value) return
      const isValid = await blockDriverFormRef.value.validate()
      if (!isValid) return
      if (inactivation.autoResolveOn) {
        inactivation.autoResolveOn = new Date(inactivation.autoResolveOn).toISOString()
      } else {
        delete inactivation.autoResolveOn
      }
      try {
        submitting.value = true
        await store.dispatch('driverView/createDriverInactivation', {
          ...inactivation,
          note: `${blockReason.value}, ${inactivation.note}`,
        })
        blockDriverModalRef.value.hide()
        ctx.emit('refetch-inactivations')
        ctx.emit('refetch-driver-details')
      } catch (error) {
        console.log(error)
      } finally {
        submitting.value = false
      }
    }
    const hiddenHandler = () => Object.keys(inactivation).forEach(k => {
      inactivation[k] = INACTIVATION_STATE_SNAPSHOT[k]
      blockReason.value = 'Permanent'
    })
    return {
      blockDriverModalRef,
      blockDriverFormRef,
      submitInactivation,
      hiddenHandler,
      submitting,
      required,
      inactivation,
      blockingReasons,
      blockReason,
    }
  },
}
</script>

<style>

</style>
